/* ==========================================================================
   BOZ3D theme behaviour
   - cart drawer (open/close, AJAX add + remove, section re-render)
   - mobile menu drawer
   - FAQ accordion (one open at a time)
   Everything is delegated off document, so markup swapped in by the Section
   Rendering API keeps working without rebinding.
   ========================================================================== */
(function () {
  'use strict';

  var CART_SECTION = 'boz-cart-drawer';
  var focusReturn = null;

  /* ---------------------------------------------------------------- utils */

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function lockScroll(on) {
    document.body.style.overflow = on ? 'hidden' : '';
  }

  function trapFocus(panel) {
    if (!panel) return;
    var focusable = panel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusable.length) focusable[0].focus();
  }

  /* ----------------------------------------------------------- cart drawer */

  function cartEl() {
    return $('[data-boz-cart]');
  }

  function openCart() {
    var el = cartEl();
    if (!el) return;
    focusReturn = document.activeElement;
    el.hidden = false;
    lockScroll(true);
    trapFocus($('.boz-cart-drawer__panel', el));
  }

  function closeCart() {
    var el = cartEl();
    if (!el) return;
    el.hidden = true;
    lockScroll(false);
    if (focusReturn && focusReturn.focus) focusReturn.focus();
    focusReturn = null;
  }

  function setBusy(on) {
    var el = cartEl();
    if (el) el.classList.toggle('is-busy', !!on);
  }

  function updateCount(count) {
    document.querySelectorAll('[data-boz-cart-count]').forEach(function (node) {
      node.textContent = count;
    });
  }

  // Pull fresh drawer markup from the server and swap it in.
  function refreshCart() {
    return fetch(window.Shopify.routes.root + '?sections=' + CART_SECTION)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var html = data[CART_SECTION];
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-boz-cart]');
        var current = cartEl();
        if (!fresh || !current) return;

        var wasOpen = !current.hidden;
        current.innerHTML = fresh.innerHTML;
        current.hidden = !wasOpen;

        // Count comes straight from cart.js so the pill can never lie.
        return fetch(window.Shopify.routes.root + 'cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            updateCount(cart.item_count);
          });
      });
  }

  // Add to cart. `form` is a real <form> so file inputs and line item
  // properties ride along untouched.
  function addFromForm(form) {
    var body = new FormData(form);
    setBusy(true);

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body,
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          showFormError(form, res.data.description || res.data.message || 'Could not add to cart.');
          return;
        }
        clearFormError(form);
        return refreshCart().then(openCart);
      })
      .catch(function () {
        showFormError(form, 'Something went wrong. Please try again.');
      })
      .finally(function () {
        setBusy(false);
      });
  }

  function showFormError(form, message) {
    var slot = form.querySelector('[data-boz-form-error]');
    if (!slot) return;
    slot.textContent = message;
    slot.hidden = false;
  }

  function clearFormError(form) {
    var slot = form.querySelector('[data-boz-form-error]');
    if (!slot) return;
    slot.textContent = '';
    slot.hidden = true;
  }

  function removeLine(key) {
    setBusy(true);
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    })
      .then(function () {
        return refreshCart();
      })
      .finally(function () {
        setBusy(false);
      });
  }

  /* ----------------------------------------------------------- menu drawer */

  function menuEl() {
    return $('[data-boz-menu]');
  }

  function openMenu() {
    var el = menuEl();
    if (!el) return;
    focusReturn = document.activeElement;
    el.hidden = false;
    lockScroll(true);
    var burger = $('[data-boz-menu-open]');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    trapFocus($('.boz-menu-drawer__panel', el));
  }

  function closeMenu() {
    var el = menuEl();
    if (!el) return;
    el.hidden = true;
    lockScroll(false);
    var burger = $('[data-boz-menu-open]');
    if (burger) {
      burger.setAttribute('aria-expanded', 'false');
      burger.focus();
    }
  }

  /* -------------------------------------------------------- event wiring */

  document.addEventListener('click', function (event) {
    var t = event.target;

    if (t.closest('[data-boz-cart-open]')) {
      event.preventDefault();
      openCart();
      return;
    }

    if (t.closest('[data-boz-cart-close]')) {
      event.preventDefault();
      closeCart();
      return;
    }

    var removeBtn = t.closest('[data-boz-cart-remove]');
    if (removeBtn) {
      event.preventDefault();
      removeLine(removeBtn.getAttribute('data-boz-cart-remove'));
      return;
    }

    if (t.closest('[data-boz-menu-open]')) {
      event.preventDefault();
      openMenu();
      return;
    }

    if (t.closest('[data-boz-menu-close]')) {
      event.preventDefault();
      closeMenu();
      return;
    }

    // Close any open desktop nav dropdown when clicking elsewhere.
    if (!t.closest('.boz-header__has-menu')) {
      document.querySelectorAll('.boz-header__has-menu[open]').forEach(function (d) {
        d.open = false;
      });
    }
  });

  // Every add-to-cart — product page and grid card alike — comes through here.
  // stopPropagation keeps a quick-add inside a card from bubbling into any
  // surrounding click handler or link wrapper.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-boz-product-form]')) return;
    event.preventDefault();
    event.stopPropagation();
    addFromForm(form);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      var cart = cartEl();
      var menu = menuEl();
      if (cart && !cart.hidden) closeCart();
      else if (menu && !menu.hidden) closeMenu();
      return;
    }

    // Wrap Tab inside whichever drawer is open, so keyboard focus can't
    // escape into the page behind the overlay.
    if (event.key === 'Tab') {
      var openPanel = null;
      var cartOpen = cartEl();
      var menuOpen = menuEl();
      if (cartOpen && !cartOpen.hidden) openPanel = cartOpen.querySelector('.boz-cart-drawer__panel');
      else if (menuOpen && !menuOpen.hidden) openPanel = menuOpen.querySelector('.boz-menu-drawer__panel');
      if (!openPanel) return;

      var focusables = openPanel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      } else if (!openPanel.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  /* ------------------------------------------------------- FAQ accordion */

  // One open at a time, per the design.
  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details.matches || !details.matches('[data-boz-faq-item]')) return;
    if (!details.open) return;
    var group = details.closest('[data-boz-faq]');
    if (!group) return;
    group.querySelectorAll('[data-boz-faq-item][open]').forEach(function (other) {
      if (other !== details) other.open = false;
    });
  }, true);

  /* ---------------------------------------------------- expose for sections */

  window.BozCart = {
    open: openCart,
    close: closeCart,
    refresh: refreshCart,
    addFromForm: addFromForm,
  };
})();
